<div class="space-y-4 text-center">
    <h1
        class="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl/none"
    >
        Almost Done!
    </h1>
</div>
<div class="max-w-sm space-y-4 mt-4">
    <div class="flex flex-col w-full">
        <div
            class="flex w-full mx-auto rounded-md text-center bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
            Check your email and click the verification link.
        </div>
    </div>
</div>
